var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getNotebook } from './swirrlApiMethods';
const getStageSize = (stage, serviceUrlToken) => __awaiter(void 0, void 0, void 0, function* () {
    const contents = (yield fetch(`${serviceUrlToken[0]}/api/contents/data/staginghistory/${stage}?${serviceUrlToken[1]}`)
        .then((res) => res.json())
        .catch((e) => console.log(e)));
    const fileinfo = (yield fetch(`${serviceUrlToken[0]}/api/contents/data/staginghistory/${stage}/swirrl_fileinfo.json?${serviceUrlToken[1]}`)
        .then((res) => res.json())
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        .then((data) => JSON.parse(data.content))
        .catch((err) => console.error(err)));
    const filenames = fileinfo.files
        .filter((file) => file.state !== 'unchanged')
        .map((file) => file.filename);
    return contents.content.reduce((size, file) => (filenames.includes(file.name) ? file.size : 0) + size, 0);
});
const getNotebookDataSize = (serviceUrl) => __awaiter(void 0, void 0, void 0, function* () {
    const serviceUrlToken = serviceUrl.split('?');
    const staginghistory = (yield fetch(`${serviceUrlToken[0]}/api/contents/data/staginghistory?${serviceUrlToken[1]}`, {
        cache: 'no-store',
    })
        .then((res) => (res.status === 200 ? res.json() : undefined))
        .catch((err) => console.error(err)));
    if (staginghistory) {
        const stages = staginghistory.content.map((stage) => stage.name);
        let size = 0;
        while (stages.length > 0) {
            const sizePromises = stages
                .splice(0, 30)
                .map((stage) => getStageSize(stage, serviceUrlToken));
            // eslint-disable-next-line no-await-in-loop
            const sizes = yield Promise.all(sizePromises);
            // eslint-disable-next-line @typescript-eslint/no-loop-func
            sizes.forEach((s) => {
                size += s;
            });
        }
        return size;
    }
    return 0;
});
export const parseSize = (size) => {
    if (size < 0)
        return '';
    if (size < 1000)
        return `${size} B`;
    let remainder = size;
    // eslint-disable-next-line no-restricted-syntax
    for (const prefix of 'kMGTPEZ'.split('')) {
        remainder /= 1000;
        if (remainder / 1000 < 1) {
            return `${+remainder.toFixed(2)} ${prefix}B`;
        }
    }
    return `${+remainder.toFixed(2)} YB`;
};
export const getNotebookInfo = (notebookId, notebookURL) => __awaiter(void 0, void 0, void 0, function* () {
    const currentSizePromise = getNotebookDataSize(notebookURL);
    const notebookPromise = getNotebook(notebookId);
    const currentSize = yield currentSizePromise;
    const notebook = JSON.parse(yield notebookPromise);
    const currentStatus = notebook.notebookStatus;
    return {
        currentSize,
        currentStatus,
    };
});
